import { MediaContent } from './media-content';

export class MediaRadio extends MediaContent {
  url: string;
  genres: string;
  country: string;
  iconUrl: string;
  bitrate: number;

  constructor(
    name: string,
    url: string,
    genres: string,
    country: string,
    iconUrl: string,
    bitrate: number
  ) {
    super(name);
    this.url = url;
    this.genres = genres;
    this.country = country;
    this.iconUrl = iconUrl;
    this.bitrate = bitrate;
  }
}
